import { useEffect, useState, useContext, useCallback } from "react";
import {
  checkFeatureEnabled,
  timeFrameFormatter
} from "../util/helper/helperFunctions";

import "../assets/css/TimeMachine/timeMachineV2.css";
import "../assets/css/TimeMachine/timeMachine.css";
import { AppContext } from "../Context/Context";
import TimeMachineMap from "../components/TimeMachine/TimeMachineMap";
import TimeMachineV2Controller from "../components/Modal/TimeMachineController/TimeMachineV2Controller";
import { getTimeMachineData } from "../util/network/databricksHandler";
import TimeMachineRangePopup from "../components/TimeMachine/TimeMachineRangePopup";

import {
  groupLgvsByTimeFrame,
  groupDockByTimeFrame,
  groupProductinLineByTimeFrame,
  groupRackByTimeFrame,
  groupBlockByTimeFrame,
  generateTimeFrame,
  getTimeInISOFromZero
} from "../components/TimeMachine/helperFunction";
import { useParams } from "react-router-dom";
import AlertMessage from "../components/Reusables/AlertMessage/AlertMessage";
import { useDispatch } from "react-redux";
import { setTimeMachineMaxTimeStamp, setTimeMachineV2ModeIsEnabled } from "../store/newTimeMachineSlice";

// Please double check before modifying any date object direcly it will
// direct to whole timemachine feature to loading state
const TimeMachineV2 = () => {
  const { plantCode } = useParams();
  const dispatch = useDispatch();
  const {
    timeMachineTimeFrames,
    setOpenTimeMachineRangePopup,
    alertObject
  } = useContext(AppContext);

  const [isDataLoading, setIsDataLoading] = useState(false);
  const [isTimePopupLoading, setIsTimePopupLoading] = useState(false);
  const [startTimeObj, setstartTimeObj] = useState(null);
  const [endTimeObj, setEndTimeObj] = useState();
  const [isPlaying, setIsPlaying] = useState(false);
  const [isNextMinuteDataLoaded, setIsNextMinuteDataLoaded] = useState(false);
  const [isPreviousMinuteDataLoaded, setIsPreviousMinuteDataLoaded] =
    useState(false);
  const [currentTimeObj, setCurrentTimeObj] = useState();
  const [lastRequestTimeObj, setLastRequestTimeObj] = useState(null);
  const [liveData, setLiveData] = useState({});
  const [timeFrame, setTimeFrame] = useState([]);

  const [framesData, setFramesData] = useState({}); // generateTimeFrame(startTimeObj, endTimeObj)

  const [playbackRate, setPlaybackRate] = useState(1);
  const [isPlayingForward, setIsPlayingForward] = useState(true);

  const resetTimeMachine = useCallback(() => {
    setIsPlaying(false);
    setPlaybackRate(1);
    setIsPlayingForward(true);
    setIsNextMinuteDataLoaded(false);
    setIsPreviousMinuteDataLoaded(false);
    setCurrentTimeObj(null);
    setLiveData({});
    setFramesData({});
    setstartTimeObj(null);
    setEndTimeObj(null);
  }, []);

  // Function to set live data
  const setLiveDataFunc = useCallback(
    (currentTimeObj) => {
      const timeKey = currentTimeObj.toISOString();
      const currentMinunteObj = new Date(currentTimeObj);
      currentMinunteObj.setSeconds(0);
      let currentMinunteKey = currentMinunteObj.toISOString();
      setLiveData({
        LGV: framesData[timeKey]?.LGV || {},
        // BLOCK: framesData[timeKey]?.BLOCK || {},
        DOCKDOOR:
          framesData[timeKey]?.DOCKDOOR ||
          framesData[currentMinunteKey]?.DOCKDOOR ||
          {},
        PRODUCTION_LINE:
          framesData[timeKey]?.PRODUCTION_LINE ||
          framesData[currentMinunteKey]?.PRODUCTION_LINE ||
          {},
        RACK:
          framesData[timeKey]?.RACK ||
          framesData[currentMinunteKey]?.RACK ||
          [],
        BLOCK:
          framesData[timeKey]?.BLOCK ||
          framesData[currentMinunteKey]?.BLOCK ||
          []
      });
    },
    [framesData]
  );

  // Load the next minute data if the current second is >= 30
  const loadNextMinuteData = useCallback(
    (currentTimeObj) => {
      if (currentTimeObj.getSeconds() >= 30) {
        if (!isNextMinuteDataLoaded) {
          let tmObj = new Date(currentTimeObj.getTime());
          tmObj.setMinutes(currentTimeObj.getMinutes() + 1);
          tmObj.setSeconds(0);
          if (tmObj < endTimeObj) {
            setIsNextMinuteDataLoaded(true);
            loadData(tmObj);
          }
        }
      } else if (currentTimeObj.getSeconds() === 0) {
        setIsNextMinuteDataLoaded(false);
      }
    },
    [isNextMinuteDataLoaded, endTimeObj]
  );

  const loadPreviousMinuteData = useCallback(
    (currentTimeObj) => {
      if (currentTimeObj.getSeconds() <= 30) {
        if (!isPreviousMinuteDataLoaded) {
          const tmObj = new Date(currentTimeObj.getTime());
          tmObj.setMinutes(currentTimeObj.getMinutes() - 1);
          tmObj.setSeconds(0);
          if (tmObj > startTimeObj) {
            setIsPreviousMinuteDataLoaded(true);
            loadData(tmObj);
          }
        }
      } else if (currentTimeObj.getSeconds() === 59) {
        setIsPreviousMinuteDataLoaded(false);
      }
    },
    [isPreviousMinuteDataLoaded, endTimeObj]
  );

  const mergeValuesInFrameData = (newObj) => {
    if (Object.keys(newObj).length) {
      setFramesData((prevData) => {
        Object.keys(newObj).forEach((key) => {
          if (prevData[key]) {
            //
            prevData[key] = { ...prevData[key], ...newObj[key] };
          } else {
            //
            prevData[key] = { ...newObj[key] };
          }
        });
        return {
          ...prevData
          // Adding new key
        };
      });
    }
  };
  // Load data functions
  const loadLGVData = useCallback(
    async (timeObj) => {
      let { startTime, endTime } = getTimeInISOFromZero(timeObj);
      let lgvResp = await getTimeMachineData(
        "LGV",
        plantCode,
        startTime,
        endTime
      );
      if (lgvResp) {
        let lgvDataFrame = groupLgvsByTimeFrame(lgvResp);

        let newFrameData = {};
        for (let timestamp in lgvDataFrame) {
          newFrameData[timestamp] = {
            LGV: lgvDataFrame[timestamp]
          };
        }

        mergeValuesInFrameData(newFrameData);
      }
    },
    [framesData, plantCode]
  );

  const loadMinMaxTimeLimit = useCallback(async () => {
    setIsTimePopupLoading(true);
    setIsDataLoading(true);
    let data = await getTimeMachineData("MAX_TIMESTAMP_FINDER", plantCode);
    if (data) {
      dispatch(setTimeMachineMaxTimeStamp(data[0]?.maxTimestamp));
      setIsTimePopupLoading(false);
      setIsDataLoading(false);
      setOpenTimeMachineRangePopup(true);
    }
  }, []);

  const loadProductionLinesData = useCallback(
    async (timeObj) => {
      let { startTime, endTime } = getTimeInISOFromZero(timeObj);

      let productionLineResp = await getTimeMachineData(
        "PROD_LINES",
        plantCode,
        startTime,
        endTime
      );
      if (productionLineResp) {
        let productionLineDataFrame =
          groupProductinLineByTimeFrame(productionLineResp);

        let newFrameData = {};
        for (let timestamp in productionLineDataFrame) {
          newFrameData[timestamp] = {
            PRODUCTION_LINE: productionLineDataFrame[timestamp]
          };
        }

        mergeValuesInFrameData(newFrameData);
        // setFramesData(prevData => ({
        //   ...prevData,
        //   ...newFrameData, // Adding new key
        // }));

        // setFramesData(framesData);
        // setIsPlaying(true);
      }
    },
    [framesData, plantCode]
  );

  const loadRackData = useCallback(
    async (timeObj) => {
      let { startTime, endTime } = getTimeInISOFromZero(timeObj);
      // auth = "dapia0e33c89f0f76440821ccea79363ecc4";

      let rackResp = await getTimeMachineData(
        "RACK_STORAGES",
        plantCode,
        startTime,
        endTime
      );
      if (rackResp) {
        let rackDataFrame = groupRackByTimeFrame(rackResp);

        let newFrameData = {};
        for (let timestamp in rackDataFrame) {
          newFrameData[timestamp] = {
            RACK: rackDataFrame[timestamp]
          };
        }

        mergeValuesInFrameData(newFrameData);
      }
    },
    [framesData, plantCode]
  );

  const loadBlockData = useCallback(
    async (timeObj) => {
      let { startTime, endTime } = getTimeInISOFromZero(timeObj);

      let blockResp = await getTimeMachineData(
        "BLOCK_STORAGES",
        plantCode,
        startTime,
        endTime
      );
      if (blockResp) {
        let blockDataFrame = groupBlockByTimeFrame(blockResp);

        let newFrameData = {};
        for (let timestamp in blockDataFrame) {
          newFrameData[timestamp] = {
            BLOCK: blockDataFrame[timestamp]
          };
        }

        mergeValuesInFrameData(newFrameData);
      }
    },
    [framesData, plantCode]
  );

  const loadDockDoorData = useCallback(
    async (timeObj) => {
      let { startTime, endTime } = getTimeInISOFromZero(timeObj);
      let dockResp = await getTimeMachineData(
        "DOCKS",
        plantCode,
        startTime,
        endTime
      );
      if (dockResp) {
        let dockDoorDataFrame = groupDockByTimeFrame(dockResp);

        let newFrameData = {};
        for (let timestamp in dockDoorDataFrame) {
          newFrameData[timestamp] = {
            DOCKDOOR: dockDoorDataFrame[timestamp]
          };
        }

        mergeValuesInFrameData(newFrameData);
      }
    },
    [framesData, plantCode]
  );

  // Load data for a given time
  const loadData = useCallback(
    (startTime) => {
      loadLGVData(startTime);
      loadBlockData(startTime);
      loadDockDoorData(startTime);
      loadProductionLinesData(startTime);
      loadRackData(startTime);
    },
    [loadLGVData, loadDockDoorData]
  );

  const calcCurrentSeekSecond = useCallback(() => {
    if (currentTimeObj) {
      try {
        let value = timeFrame.indexOf(currentTimeObj?.toISOString());
        if (value && value > -1) return value;
      } catch (error) {}
    }
    return 0;
  }, [currentTimeObj, timeFrame]);

  const backward15Seconds = useCallback(() => {
    let tempObj = currentTimeObj.setSeconds(currentTimeObj.getSeconds() - 15);
    tempObj = new Date(tempObj);
    if (tempObj <= startTimeObj) {
      setCurrentTimeObj(new Date(startTimeObj));
      setIsPlaying(false);
    } else {
      setCurrentTimeObj(tempObj);
    }
  }, [currentTimeObj, startTimeObj]);

  const isLiveDataAvailabe = (currentTimeObj) => {
    const currentMinunteObj = new Date(currentTimeObj);
    currentMinunteObj.setSeconds(0);
    let currentMinunteKey = currentMinunteObj.toISOString();
    const getLength = (key, timeKey = currentMinunteKey) =>
      Object.keys(framesData?.[timeKey]?.[key] || {}).length;
    if (
      getLength("LGV", currentTimeObj.toISOString()) &&
      ["DOCKDOOR", "PRODUCTION_LINE", "RACK", "BLOCK"].every((key) =>
        getLength(key)
      )
    ) {
      if (isDataLoading) setIsDataLoading(false);
      setIsPlaying(true);
      return true;
    } else {
      setIsDataLoading(true);
      setIsPlaying(false);
      if (
        lastRequestTimeObj &&
        lastRequestTimeObj.getTime() !== currentTimeObj.getTime()
      ) {
        loadData(currentTimeObj);
      }
      setLastRequestTimeObj(new Date(currentTimeObj));
    }
  };

  const handleOnChange = (second) => {
    if (second >= timeFrame.length) second = timeFrame.length - 1;

    let timestamp = timeFrame[second];
    setCurrentTimeObj(new Date(timestamp));
  };

  const forwarded15Seconds = useCallback(() => {
    let tempObj = currentTimeObj.setSeconds(currentTimeObj.getSeconds() + 15);
    tempObj = new Date(tempObj);
    if (tempObj >= endTimeObj) {
      let onesecondLessByEndTime = new Date(endTimeObj);
      onesecondLessByEndTime.setSeconds(
        onesecondLessByEndTime.getSeconds() - 1
      );
      setCurrentTimeObj(onesecondLessByEndTime);
      setIsPlaying(false);
    } else {
      setCurrentTimeObj(tempObj);
    }
  }, [currentTimeObj, endTimeObj]);

  // Effect to handle the interval logic
  useEffect(() => {
    if (!isPlaying || currentTimeObj > endTimeObj) return;

    const oneSecondBeforeEnd = new Date(endTimeObj.getTime() - 1000);
    const oneSecondBeforeStart = new Date(startTimeObj.getTime() - 1000);

    const interval = setInterval(() => {
      if (!isPlaying) return;

      const withinBounds =
        currentTimeObj < oneSecondBeforeEnd &&
        ((isPlayingForward && currentTimeObj >= oneSecondBeforeStart) ||
          (!isPlayingForward && currentTimeObj > startTimeObj));

      if (withinBounds) {
        if (isLiveDataAvailabe(currentTimeObj)) {
          setLiveDataFunc(currentTimeObj);

          const nextTime = new Date(
            currentTimeObj.getTime() + (isPlayingForward ? 1000 : -1000)
          );

          if (isPlayingForward) {
            loadNextMinuteData(currentTimeObj);
          } else {
            loadPreviousMinuteData(currentTimeObj);
          }

          setCurrentTimeObj(nextTime);
        }
      } else {
        // Stop playback when out of bounds
        setIsPlaying(false);
        setPlaybackRate(1);
        setIsPlayingForward(true);
      }
    }, 1000 / playbackRate);

    return () => clearInterval(interval);
  }, [
    playbackRate,
    isPlayingForward,
    isPlaying,
    currentTimeObj,
    framesData,
    loadNextMinuteData,
    setLiveDataFunc,
    endTimeObj
  ]);

  useEffect(() => {
    if (currentTimeObj) {
      isLiveDataAvailabe(currentTimeObj);
    }
  }, [framesData, currentTimeObj]);

  useEffect(() => {
    dispatch(setTimeMachineV2ModeIsEnabled(true));
    if (Object.keys(timeMachineTimeFrames).length === 0) {
      loadMinMaxTimeLimit();
    }
  }, []);

  useEffect(() => {
    resetTimeMachine();
    if (Object.keys(timeMachineTimeFrames).length) {
      let { fromTimePlant, toTimePlant } = timeFrameFormatter(
        timeMachineTimeFrames
      );
      // fromTimePlant = "2024-09-01T00:00:00.000Z";
      // toTimePlant = "2024-09-01T00:12:00.000Z";

      // fromTimePlant = "2024-09-02T18:41:00.000Z";
      // toTimePlant = "2024-09-02T18:45:00.000Z";

      setstartTimeObj(new Date(fromTimePlant));
      setCurrentTimeObj(new Date(fromTimePlant));
      setEndTimeObj(new Date(toTimePlant));
    }
  }, [timeMachineTimeFrames, resetTimeMachine]);

  useEffect(() => {
    if (startTimeObj && endTimeObj) {
      setIsDataLoading(true);
      loadData(startTimeObj);
      setTimeFrame(generateTimeFrame(startTimeObj, endTimeObj));
    }
  }, [startTimeObj, endTimeObj]);

  //reset on exiting the new time machine mode on page leave
  useEffect(() => {
    return () => {
      dispatch(setTimeMachineV2ModeIsEnabled(false));
    };
  }, []);

  return (
    <div className="new-ui map-container-wrapper">
      <TimeMachineMap
        liveData={liveData}
        timeMachineTimeFrames={timeMachineTimeFrames}
        isDataLoading={isDataLoading}
        isTimePopupLoading={isTimePopupLoading}
      />

      {timeMachineTimeFrames.fromDate && (
        <TimeMachineV2Controller
          totalSeekPosition={timeFrame.length}
          currentSeekPosition={calcCurrentSeekSecond()}
          backward15Seconds={backward15Seconds}
          forwarded15Seconds={forwarded15Seconds}
          isPlaying={isPlaying}
          setIsPlaying={setIsPlaying}
          isPlayingForward={isPlayingForward}
          setPlaybackRate={setPlaybackRate}
          playbackRate={playbackRate}
          setIsPlayingForward={setIsPlayingForward}
          handleOnChange={handleOnChange}
          timeFrame={timeFrame}
        />
      )}

      {alertObject.type.length !== 0 ? (
        <AlertMessage
          heading={alertObject.payload.heading}
          description={alertObject.payload.description}
          type={alertObject.type}
        />
      ) : null}

      <TimeMachineRangePopup />
    </div>
  );
};

export default TimeMachineV2;
